import { Box, Link, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

type InfoBannerVariant = 'info' | 'warning';

type InfoBannerProps = {
  variant?: InfoBannerVariant;
  children: ReactNode;
};

const VARIANT_STYLES: Record<InfoBannerVariant, { bg: string; border: string; color: string }> = {
  info: { bg: '#EBF8FF', border: '#BEE3F8', color: '#2C5282' },
  warning: { bg: '#FFFAF0', border: '#FEEBC8', color: '#744210' },
};

const InfoBanner: FC<InfoBannerProps> = ({ variant = 'info', children }) => {
  const s = VARIANT_STYLES[variant];
  return (
    <Box
      style={{
        padding: '10px 14px',
        background: s.bg,
        border: `1px solid ${s.border}`,
        borderRadius: 4,
        marginTop: 8,
      }}
    >
      <Typography variant="body2" style={{ fontSize: 13, color: s.color, lineHeight: 1.5 }}>
        {children}
      </Typography>
    </Box>
  );
};

export const InfoBannerLink: FC<{ href: string; children: ReactNode }> = ({ href, children }) => (
  <Link href={href} target="_blank" rel="noopener noreferrer" style={{ color: '#3182CE' }}>
    {children}
  </Link>
);

export default InfoBanner;
